import React, { useState } from "react";
import "./ContactUs.css";
import mailData from "./../data/mailData";

function ContactUs() {
  return (
    <>
      <div className="main-banner">
        <img
          src="images/Home/banner-home.png"
          alt="banner"
          className="banner-img"
        />
      </div>
      <div className="contact-us-container">
        <div className="home-box">
          <h2 className="main-headings">Contact Learning support</h2>
        </div>
        <div className="contact-us-wrap">
          <div className="contact-us-row row1">
            <div className="contact-us-box">
              <div className="contact-us-sub-row row1">
                <div className="contact-us-sub-box">
                  <h3>For Americas</h3>
                  <div className="contact-content-box">
                    <p>Veena Oruganti</p>
                    <p>
                      <a href="mailto:veena.oruganti" className="contact_anchor">                        
                        {mailData.contactUsPage.veena}@{mailData.domain}
                      </a >
                    </p>
                  </div>
                  <div className="contact-content-box">
                    <p>Amrita Verma</p>
                    <p>
                      <a href="mailto:amrita.verma" className="contact_anchor">                        
                        {mailData.contactUsPage.amrita}@{mailData.domain}
                      </a>
                    </p>
                  </div>
                  <img
                    src="images/Contact/Americas.png"
                    alt="map"
                    className="map-icon"
                  />
                </div>
              </div>
              <div className="contact-us-sub-row row2">
                <div className="contact-us-sub-box">
                  <h3>For EMEA</h3>
                  <div className="contact-content-box">
                    <p>Devika Gajanan Pote</p>
                    <p>
                      <a href="mailto:devika.gajanan.pote" className="contact_anchor">                        
                        {mailData.contactUsPage.devika}@{mailData.domain}
                      </a>
                    </p>
                  </div>
                  <div className="contact-content-box">
                    <p>Sharda Mankare</p>
                    <p>
                      <a href="mailto:sharda.mankare" className="contact_anchor">                        
                        {mailData.contactUsPage.sharda}@{mailData.domain}
                      </a>
                    </p>
                  </div>
                  <img
                    src="images/Contact/EMEA.png"
                    alt="map"
                    className="map-icon"
                  />
                </div>
              </div>
              <div className="contact-us-sub-row row3">
                <div className="contact-us-sub-box">
                  <h3>For Philippines</h3>
                  <div className="contact-content-box">
                    <p>Marc Harvie L. Calim</p>
                    <p>
                      <a href="mailto:marc.harvie.l.calim" className="contact_anchor">                        
                        {mailData.contactUsPage.marc}@{mailData.domain}
                      </a>
                    </p>
                    <p style={{ marginLeft: "40px" }}>Nico Simon</p>
                    <p>
                      <a href="mailto:christopher.n.simon" className="contact_anchor">                        
                        {mailData.contactUsPage.christopher}@{mailData.domain}
                      </a>
                    </p>
                  </div>
                  <img
                    src="images/Contact/Philippines.png"
                    alt="map"
                    className="map-icon"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="contact-us-row row2">
            <div className="contact-us-box">
              <h3>For APAC</h3>
              <div className="contact-content-box">
                <p>Racquel Ann S. Felix <br/> <span className="region_sp">APAC</span></p>
                <p>
                  <a href="mailto:racquel.ann.s.felix" className="contact_anchor">                    
                    {mailData.contactUsPage.racquel}@{mailData.domain}
                  </a>
                </p>
              </div>
              <div className="contact-content-box">
                <p>Ankita Mishra <br/> <span className="region_sp">Vietnam</span></p>
                <p>
                  <a href="mailto:ankita.ag.mishra" className="contact_anchor">                    
                    {mailData.contactUsPage.ankita}@{mailData.domain}
                  </a>
                </p>
              </div>
              <div className="contact-content-box">
                <p>Amrutha Reddy <br/> <span className="region_sp">Malaysia</span></p>
                <p>
                  <a href="mailto:amrutha.c.reddy" className="contact_anchor">                    
                    {mailData.contactUsPage.amrutha}@{mailData.domain}
                  </a>
                </p>
              </div>
              <div className="contact-content-box">
                <p>Hemashree Janardhan <br/> <span className="region_sp">Indonesia</span></p>
                <p>
                  <a href="mailto:hemashree.janardhan" className="contact_anchor">                    
                    {mailData.contactUsPage.hemashree}@{mailData.domain}
                  </a>
                </p>
              </div>
              <img
                src="images/Contact/APAC.png"
                alt="map"
                className="map-icon"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ContactUs;
